import { Col } from 'react-bootstrap';
import styled from 'styled-components';

export const FormDescriptionCol = styled(Col)`
      .jodit-container:not(.jodit_inline) .jodit-workplace {
            min-height: ${(props) => props.height} !important;
      }
`;
